import script from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawSummary.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawSummary.vue?vue&type=style&index=0&id=7d8d41f3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8d41f3"]])

export default __exports__